import { render, staticRenderFns } from "./Lotes1.vue?vue&type=template&id=21e621a2&"
import script from "./Lotes1.vue?vue&type=script&lang=js&"
export * from "./Lotes1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports